module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAA5UlEQVR4nO3ZMU7DMACF4eeKBSQE94MdVgbEIbgAXSs4HwwIBiTM0qkymWKnhO9bnUhPTrY/AQAAAAAAAKC78ttBrfUsyWOSqyQXwxb9TW9JXpLcl1I+Ww9MXfRTkptOw9ZqW0q5bR00L7rWuknynuS056oV+khyXkr5PjzYLDDmX2pe9P6L7AZvWYNd629OkpOJl+6SfCW5TnLZY9WKvCZ5TvKw9BAAAAAAgCMlzs5DnB1MnB1EnF2aODsvcbYzcRYAAAAAYJo4Ow9xdjBxdhBxdmni7LzE2c7EWQAAAAAAAIBj8AN5wEuaVS49SwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hamburger-white.png
// module id = 1131
// module chunks = 22 47 48 65 66